import React from "react";
import {useDispatch} from "react-redux";
import {addCompanyOnAPI} from "../../actions/companies";
import {addTextbausteinOnAPI} from "../../actions/textbausteine";
import schools from "../../data/schools.json";
import textbausteine from "../../data/textbausteine.json";
import users from "../../data/users";
import {simpleRequest} from "../../newForms2/simpleRequest";

const InitFields = () => {
  const dispatch = useDispatch();

  const initialSchools = async () => {
    console.log({schools});
    for (let i = 0; i < schools.length; i++) {
      const school = schools[i];
      const data = {
        ...school,
        type: "Schule",
        schoolnumber: `${school.schoolnumber}`
      };
      dispatch(addCompanyOnAPI({...data}));
    }
  };
  const initialTextbausteine = async () => {
    console.log({textbausteine});
    for (let i = 0; i < textbausteine.length; i++) {
      const tb = {...textbausteine[i]};
      delete tb.sort;
      delete tb.id;
      dispatch(addTextbausteinOnAPI({...tb}));
    }
  };
  const initialUsers = async () => {
    console.log({users});
    for (let i = 0; i < users.length; i++) {
      const data = {};
      [
        "username",
        "companyId",
        "title",
        "firstName",
        "salutation",
        "lastName",
        "functions",
        "email",
        "phone",
        "mobile",
        "note",
        "userStatus"
      ].forEach(item => (data[item] = users[i][item] || ""));
      console.log(data);
      await simpleRequest({url: "users", method: "post", data});
    }
  };

  return (
    <div className="my-2">
      <button className="btn btn-outline-dark mr-2" onClick={initialSchools}>
        Init Schools
      </button>
      <button className="btn btn-outline-dark mr-2" onClick={initialTextbausteine}>
        Init Textbausteine
      </button>
      <button className="btn btn-outline-dark" onClick={initialUsers}>
        Init Users
      </button>
    </div>
  );
};
export default InitFields;
